import React, { useEffect } from "react";
import { FaWallet } from "react-icons/fa";
import CountUp from "react-countup";
import axios from "axios";
import { useState } from "react";

function Wallet({ props }) {
  const [adminProfitPercentage, setAdminProfit] = useState();

  const [profitSahre, setProfitShareData] = useState();
  const [withdrawAmount, setWithdrawAmount] = useState(null);
  const [spendAmount, setSpendAmount] = useState();
  const [withdraw, setWithdraw] = useState(true);
  const [message, setMessage] = useState();

  useEffect(() => {
    axios.get(`/api/admin/profitShare`).then((res) => {
      setSpendAmount(res.data?.profitShareHistory);
      setAdminProfit(res.data?.profitShare?.profit);
      setProfitShareData(res.data?.profitShare);
    });
  }, [withdraw]);

  function adminProfit() {
    return (props?.totalIncome * adminProfitPercentage) / 100 - spendAmount;
  }

  const makeWithdraw = () => {
    let data = {
      withdraw_amount: withdrawAmount,
    };
    if(withdrawAmount ==''){
      alert('This filed is required');
    }else if(withdrawAmount < 0){
      alert('Please Enter Positive Number');
    }else{
      if (adminProfit() >= withdrawAmount) {
        axios.post(`/api/admin/profit/withdraw`, data).then((res) => {
          if (res.data.status == 200) {
            setWithdraw(true);
            setMessage("");
            setWithdrawAmount(null);
          }
          if (res.data.status == 422) {
            setMessage(res.data.errors);
          }
        });
      } else {
        setMessage({ withdraw_amount: "Incificient Balance" });
      }
    }
  };
  return (
    <>
      <div className="row justify-content-between">
        <div className="col-md-4 max-width-wallet mb-3">
          <div className="col-md-12 d-flex bg-black rounded-3">
            <div className="col-md-5">
              <div className="p-3">
                <div className="text-warning">
                  <FaWallet size={60} />
                </div>
                <div className="mt-2 text-light">
                  <h1>
                    $
                    <CountUp end={props?.totalIncome} duration={0.5} />
                  </h1>
                </div>
                <div className="text-light">Total Income</div>
              </div>
            </div>

            <div className="col-md-7 d-flex justify-content-around align-items-center">
              <div className="incomeBalance d-flex justify-content-center align-items-center fw-bold text-light"></div>
              <div className="expenditureBalance d-flex justify-content-center align-items-center fw-bold text-light"></div>
            </div>
          </div>
        </div>

        <div className="col-md-4 max-width-wallet mb-3">
          <div className="col-md-12 d-flex bg-black rounded-3">
            <div className="col-md-6">
              <div className="p-3">
                <div className="text-warning">
                  <FaWallet size={60} />
                </div>
                <div className="mt-2 text-light">
                  <h1>
                    $
                    <CountUp end={adminProfit()} duration={0.5} />
                  </h1>
                </div>
                <div className="text-light">Your Profit</div>
              </div>
            </div>
            <div className="col-md-6 d-flex flex-column justify-content-between align-items-end">
              {withdraw ? (
                <div className="text-light p-3">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => setWithdraw(false)}
                  >
                    Withdraw
                  </button>
                </div>
              ) : (
                <div>
                  <div>
                    <input
                      type="number"
                      className="reply-control m-3 p-2"
                      min={0}
                      onChange={(e) => setWithdrawAmount(e.target.value)}
                    />
                    <span className="text-danger d-flex justify-content-center">
                      {message?.withdraw_amount}
                    </span>
                  </div>
                  <div className="d-flex justify-content-center">
                    <div className="text-light p-1">
                      <button
                        className="btn btn-sm btn-success"
                        onClick={makeWithdraw}
                      >
                        Confirm
                      </button>
                    </div>
                    <div className="text-light p-1 ">
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => (setWithdraw(true), setMessage(""))}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="tr-odd-wallet">
            <table className="table w-100">
              <thead className="bg-warning">
                <tr>
                  <th scope="col" className="text-black fw-bold">
                    #
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Transaction ID
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Amount
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {profitSahre?.withdraw_history?.map((data, index) => (
                  <tr className="tr-child-wallet">
                    <th scope="row">{index + 1}</th>
                    <td>{data?.withdraw_id}</td>
                    <td>{data?.withdraw_amount}</td>
                    <td>
                      {data?.status == 0 ? (
                        <span className="badge rounded-pill bg-primary ml-1">
                          Pending
                        </span>
                      ) : data?.status == 1 ? (
                        <span className="badge rounded-pill bg-warning ml-1">
                          Processing
                        </span>
                      ) : data?.status == 2 ? (
                        <span className="badge rounded-pill bg-success ml-1">
                          Success
                        </span>
                      ) : (
                        <span className="badge rounded-pill bg-danger ml-1">
                          Failed
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Wallet;
